import { render, staticRenderFns } from "./GlobalSection.vue?vue&type=template&id=142d4069&scoped=true&"
import script from "./GlobalSection.vue?vue&type=script&lang=js&"
export * from "./GlobalSection.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSection.vue?vue&type=style&index=0&id=142d4069&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142d4069",
  null
  
)

export default component.exports